interface LoadingStateProps {
  title?: string;
  subtitle?: string;
  progress?: number;
  steps?: string[];
  currentStep?: number;
}

export function LoadingState({ title, subtitle, progress, steps, currentStep }: LoadingStateProps) {
  return (
    <div className="app-loading-state">
      <div className="app-loading-spinner" aria-hidden="true" />

      {title && (
        <h2>{title}</h2>
      )}
      {subtitle && (
        <p>{subtitle}</p>
      )}

      {progress !== undefined && (
        <div className="app-loading-track">
          <div
            className="app-loading-progress"
            style={{ width: `${Math.round(progress * 100)}%` }}
          />
        </div>
      )}

      {steps && steps.length > 0 && (
        <div className="app-loading-steps">
          {steps.map((step, i) => {
            const isDone = currentStep !== undefined ? i < currentStep : false;
            const isCurrent = currentStep !== undefined ? i === currentStep : false;
            return (
              <div
                key={i}
                className={isDone ? "is-done" : isCurrent ? "is-current" : ""}
              >
                <span>
                  {isDone ? "✓" : isCurrent ? "●" : "○"}
                </span>
                {step}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
